<div>
  <div class="fs-5" *ngIf='title'>{{ title }}</div>
  <p *ngIf='text' [innerHtml]="text"></p>
</div>